import React from 'react'
import PropTypes from 'prop-types'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import { stopEvent } from '@aytm/lib/common/func'
import Portal from '@aytm/lib/rfd-ui/components/basic/portal'

import '@aytm/lib/rfd-ui/styles/basic/light-box.scss'

export default class LightBox extends PureDataComponent {
  static propTypes = {
    onClose: PropTypes.func
  }

  constructor(...args) {
    super(...args);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const { onClose, fullSize } = this.props
    if (
      'function' == typeof onClose &&
      !fullSize &&
      (this.refLightBoxBackdrop == event.target || this.refLightBoxBackdropCenter == event.target)
    ) {
      stopEvent(event)
      onClose()
      return false
    }
    return true
  }

  render() {
    const { onClose, children, fullSize, background, className, ...otherProps } = this.props

    return (
      <Portal>
        <div
          className={`rfd-ui-light-box ${className ? className : ''}`}
          onMouseDown={this.onClick}
          ref={this.saveRef('LightBoxBackdrop')}
          style={{ backgroundColor: background }}
          {...otherProps}
        >
          <div
            className="rfd-ui-light-box-center"
            onMouseDown={this.onClick}
            ref={this.saveRef('LightBoxBackdropCenter')}
          >
            <div className="rfd-ui-light-box-center-content">{children}</div>
          </div>
        </div>
      </Portal>
    )
  }
}
